var map = {
	"./340x190_Roll_X.jpg": 2937,
	"./440x237_Double X.jpg": 7949,
	"./440x237_HUNT_X.jpg": 5760,
	"./440x237_Tug_Of_War.jpg": 2377,
	"./470x360 Mine Island.jpg": 2809,
	"./470x360_Rodeo.jpg": 5087,
	"./490x397 SmashX.png": 4681,
	"./500x500_CricketerX.jpg": 9666,
	"./Aviastar.png": 6906,
	"./Balloon.jpg": 2048,
	"./Cappadocia.jpg": 3514,
	"./CrazyHuntX.jpg": 6513,
	"./CricketX.jpg": 8821,
	"./FootballX.jpg": 3668,
	"./HelicopterX.jpg": 2224,
	"./JetX.png": 4834,
	"./PlinkoX.jpg": 7164,
	"./SpinX.jpg": 1025,
	"./TowerX.jpg": 5664,
	"./VirtualRoulette.jpg": 4552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6531;